<mat-chip
  *ngIf="item"
  class="chipCustom"
  (removed)="remove()"
  matTooltip="{{ item[key] | titlecase }}"
>
  <span
    class="chipCustom__text text"
    [ngClass]="{ 'text--isRemovible': removable }"
  >
    {{ item[key] | titlecase }}</span
  >
  <button
    type="button"
    mat-icon-button
    class="chipCustom__button button"
    aria-label="delete button"
    *ngIf="removable"
    (click)="remove()"
  >
    <mat-icon class="button__icon">close</mat-icon>
  </button>
</mat-chip>
